import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import api from '../utils/axios';

const RegisterForm = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values) => {
    try {
      setLoading(true);
     
      if (values.password !== values.confirmPassword) {
        message.error('Les mots de passe ne correspondent pas');
        return;
      }
     
      // CORRECTION ICI : Envoyer tous les champs requis
      const response = await api.post('/api/auth/register', {
        name: values.name,
        username: values.username,
        email: values.email,
        password: values.password,
        confirmPassword: values.confirmPassword
      });
     
      if (response.data.success) {
        message.success('Inscription réussie!');
        setTimeout(() => {
          navigate('/login');
        }, 1500);
      }
     
    } catch (error) {
      console.error('Erreur inscription:', error);
      message.error(error.response?.data?.message || 'Erreur d\'inscription');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.form}>
      <h2 style={styles.title}>Créer un compte</h2>
     
      <Form
        name="register"
        onFinish={onFinish}
        layout="vertical"
      >
        <Form.Item
          name="name"
          label="Nom complet"
          rules={[
            { required: true, message: 'Champ requis' }
          ]}
        >
          <Input placeholder="Votre nom complet" />
        </Form.Item>

        <Form.Item
          name="username"
          label="Nom d'utilisateur"
          rules={[
            { required: true, message: 'Champ requis' },
            { min: 3, message: 'Minimum 3 caractères' }
          ]}
        >
          <Input placeholder="Choisissez un nom d'utilisateur" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[
            { required: true, message: 'Champ requis' },
            { type: 'email', message: 'Email invalide' }
          ]}
        >
          <Input placeholder="Votre email" />
        </Form.Item>

        <Form.Item
          name="password"
          label="Mot de passe"
          rules={[
            { required: true, message: 'Champ requis' },
            { min: 6, message: 'Minimum 6 caractères' }
          ]}
        >
          <Input.Password placeholder="Choisissez un mot de passe" />
        </Form.Item>

        <Form.Item
          name="confirmPassword"
          label="Confirmer le mot de passe"
          rules={[
            { required: true, message: 'Champ requis' }
          ]}
        >
          <Input.Password placeholder="Confirmez votre mot de passe" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            block
          >
            S'inscrire
          </Button>
        </Form.Item>

        <div style={styles.footer}>
          <Button
            type="link"
            onClick={() => navigate('/login')}
          >
            Déjà un compte ? Se connecter
          </Button>
        </div>
      </Form>
    </div>
  );
};

const styles = {
  form: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  title: {
    textAlign: 'center',
    marginBottom: '25px',
    color: '#1890ff',
  },
  footer: {
    textAlign: 'center',
    marginTop: '15px',
  },
};

export default RegisterForm;